import ModelProject, { RunBuilder, Sketch, ModelConfiguration } from '../models/complex-model'
import { INF_MODEL } from '../models/complex-model/inputs'

export interface IModel {
  // (
  //   this: Project,
  //   { startTime, resolution, tickCount, sketches }: IModelProps
  // ): void
  getOffset: (p: string, e: string) => number | undefined
  getOffsetById: (id: number) => number | undefined
}

export interface IModelProps {
  startTime: number
  resolution: number
  stepCount: number
  inputs: any[]
}

interface IUpdateModel {
  outputs: string[][]
  settings: IModelProps
}

export interface IRunItem {
  id: string
  name?: string
  values: number[]
  data: { x: number, y: number }[]
}

export function createOriginalModelRun({ outputs, settings }: IUpdateModel): IRunItem[] {
  // @ts-ignore
  const builder: RunBuilder = ModelProject.buildRun(INF_MODEL)
  const modelConfiguration: ModelConfiguration = builder
    .setStartTime(settings.startTime)
    .setStepCount(settings.stepCount)
    .setResolution(settings.resolution)
    .configureModel(INF_MODEL)
  // Seems to be a bug in sheetless
  // settings.sketches.forEach((s: Sketch) => {
  //   modelConfiguration.setSketch(s as any)
  // })
  const run = builder.start()
  settings.inputs.forEach((s: any) => {
    run.setInput(INF_MODEL, s.element, s.value)
  })
  run.runToEnd()
  return outputs.map(outputMap(run))
}

const outputMap = (run: any) => (o: string[]) => ({
  id: `${o[1]}`,
  values: run.getValues(o[0], o[1]),
  data: prepChartData(run.getValues(o[0], o[1])),
})

function prepChartData(data: Float64Array) {
  const normalArray = [].slice.call(data)
  return normalArray.map((n, i) => {
    const yVal = Math.round(n * 100) / 100
    return {
      x: i,
      y: isNaN(yVal) || yVal === Infinity || yVal === -Infinity ? 0 : yVal,
    }
  })
}
